import { render } from "./IconOpenInNew.vue?vue&type=template&id=3209a2b3"
import script from "./IconOpenInNew.vue?vue&type=script&lang=js"
export * from "./IconOpenInNew.vue?vue&type=script&lang=js"
script.render = render

export default script